// extracted by mini-css-extract-plugin
export default {"price":"Price_price__u0vBX","striked":"Price_striked__uXmOe","salePrice":"Price_salePrice__kfFJU"};